import { Link } from 'react-router-dom';
import { Alert, Button } from '@mui/material';

// Why a month shows "Not configured" / nothing flagged, in words - with the way out for Finance. The server says why
// (thresholdNote.shared.js): the usual surprise is a threshold that was saved in October and so only applies from October;
// March to September then have none, which looked like "I configured it, why not showing?".
const WORD = { '<': 'below', '<=': 'at or below', '>': 'above', '>=': 'at or above', '=': 'equal to' };

const monthLabel = (value) => {
  const [year, month] = String(value).split('-').map(Number);
  return new Date(year, month - 1, 1).toLocaleString('en-GB', { month: 'long', year: 'numeric' });
};

// `canSet` comes from the page (it already knows what this person may configure - useConfigAccess), so the note asks the server for nothing.
const ThresholdNote = ({ note, month, configPath, canSet = false }) => {
  if (!note) return null;
  const label = month.format('MMMM YYYY');

  const message = {
    starts_later: `No threshold applies to ${label}: the threshold (warns when ${WORD[note.operator] || note.operator} ${note.value}) only starts in ${monthLabel(note.startsFrom || '')}, so nothing is flagged for earlier months.`,
    off: `The threshold is switched off for ${label}, so nothing is flagged.`,
    ended: `The earlier threshold stopped before ${label}, so nothing is flagged.`,
    none: 'No threshold has been set for this metric yet, so nothing is flagged.',
  }[note.reason];
  if (!message) return null;

  // Whoever may set this threshold (Finance, or a person Finance granted) gets the shortcut: the threshold screen opens in this month, with "Applies from" already set to it
  const showAction = !!configPath && canSet;
  const to = `/dashboard/warning-dashboard/${configPath}?month=${month.format('YYYY-MM-DD')}`;
  const actionLabel = note.reason === 'starts_later' ? `Apply it from ${month.format('MMM YYYY')}` : note.reason === 'none' ? 'Set a threshold' : `Set it for ${month.format('MMM YYYY')}`;

  return (
    <Alert
      severity="info"
      sx={{ mb: 2, alignItems: 'center' }}
      action={showAction ? <Button component={Link} to={to} color="inherit" size="small">{actionLabel}</Button> : undefined}
    >
      {message}
    </Alert>
  );
};

export default ThresholdNote;
